// extracted by mini-css-extract-plugin
module.exports = {"colorGroup":"index-module--color-group--22y57","colorItem":"index-module--color-item--1CA77"};